type documentLocalesType = {
  [key: string]: string
}

export const DocumentLocales: documentLocalesType = {
  fr: 'French',
  en: 'English',
  de: 'German',
  nb: 'Norwegian (Bokmål)',
  it: 'Italian',
}
